// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CompassIconSignature {
  Element: SVGSVGElement;
}

export const CompassIcon: TOC<CompassIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C1.999 6.473 6.475 2 12 2C17.528 2 22.001 6.475 22 12C22 17.528 17.525 22 12 22C6.472 22 2 17.526 2 12ZM6.343 6.343C4.832 7.854 4 9.863 4 12C4 14.096 4.805 16.067 6.262 17.568L9.088 9.088L17.567 6.262C16.067 4.805 14.097 4 12 4C9.863 4 7.854 4.832 6.343 6.343ZM10.669 10.669L13.33 13.332L9.338 14.663L10.669 10.669ZM6.434 17.739C7.934 19.195 9.904 20 12 20C16.422 20 20 16.422 20 12C20 9.904 19.195 7.933 17.738 6.432L14.912 14.912L6.434 17.739Z"/>
</svg>
</template>;